<template>
  <Page>
    <template #right>
      <van-count-down
        ref="countDown"
        :time="time"
        format="sss"
        @finish="countdownfinish"
      />
    </template>
    <div class="user-pick">
      <van-row>
        <van-col span="12" class="user-pick-left">
          <div class="user-pick-qrcode">
            <qr-code :text="stationInfo.qrcodeUrl" :size="220"></qr-code>
          </div>
          <div class="user-pick-scantext">
            <van-icon name="scan" /><span>扫码快速取件</span>
          </div>
        </van-col>
        <van-col span="12" class="user-pick-right">
          <div class="right-content">
            <h2 class="title">取件码取件</h2>
            <van-password-input
              :value="form.secret"
              :mask="false"
              :gutter="10"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
            />
            <van-number-keyboard
              v-model="form.secret"
              :show="showKeyboard"
              theme="custom"
              close-button-text="确定"
              @close="close"
            />
            <!-- <cellInput
              placeholder="请输入电话号码"
              :focus="focusKey === 'phone'"
              v-model="form.phone"
              @focusKeyChange="focusKeyChange"
              name="phone"
            /> -->
            <!-- <cellInput
              placeholder="请输入取件码"
              :focus="focusKey === 'secret'"
              v-model="form.secret"
              @focusKeyChange="focusKeyChange"
              name="secret"
            />
            <div class="keybord">
              <div class="keybord-row">
                <div class="keybord-item" @click="clickItem(1)">1</div>
                <div class="keybord-item" @click="clickItem(2)">2</div>
                <div class="keybord-item" @click="clickItem(3)">3</div>
                <div class="keybord-item" @click="clickItem(0)">0</div>
                <div class="keybord-item" @click="clickItem('del')">
                  <svg
                    viewBox="0 0 32 22"
                    xmlns="http://www.w3.org/2000/svg"
                    class="van-key__delete-icon"
                  >
                    <path
                      d="M28.016 0A3.991 3.991 0 0132 3.987v14.026c0 2.2-1.787 3.987-3.98 3.987H10.382c-.509 0-.996-.206-1.374-.585L.89 13.09C.33 12.62 0 11.84 0 11.006c0-.86.325-1.62.887-2.08L9.01.585A1.936 1.936 0 0110.383 0zm0 1.947H10.368L2.24 10.28c-.224.226-.312.432-.312.73 0 .287.094.51.312.729l8.128 8.333h17.648a2.041 2.041 0 002.037-2.04V3.987c0-1.127-.915-2.04-2.037-2.04zM23.028 6a.96.96 0 01.678.292.95.95 0 01-.003 1.377l-3.342 3.348 3.326 3.333c.189.188.292.43.292.679 0 .248-.103.49-.292.679a.96.96 0 01-.678.292.959.959 0 01-.677-.292L18.99 12.36l-3.343 3.345a.96.96 0 01-.677.292.96.96 0 01-.678-.292.962.962 0 01-.292-.68c0-.248.104-.49.292-.679l3.342-3.348-3.342-3.348A.963.963 0 0114 6.971c0-.248.104-.49.292-.679A.96.96 0 0114.97 6a.96.96 0 01.677.292l3.358 3.348 3.345-3.348A.96.96 0 0123.028 6z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </div>
              </div>
              <div style="width:60%;float:left;">
                <div class="keybord-row">
                  <div class="keybord-item" @click="clickItem(4)">4</div>
                  <div class="keybord-item" @click="clickItem(5)">5</div>
                  <div class="keybord-item" @click="clickItem(6)">6</div>
                </div>
                <div class="keybord-row">
                  <div class="keybord-item" @click="clickItem(7)">7</div>
                  <div class="keybord-item" @click="clickItem(8)">8</div>
                  <div class="keybord-item" @click="clickItem(9)">9</div>
                </div>
              </div>
              <div style="width:40%; float:right;">
                <div class="keybord-item confirm" @click="clickItem('confirm')">
                  确定
                </div>
              </div>
            </div> -->
          </div>
        </van-col>
      </van-row>
    </div>
  </Page>
</template>

<script>
import { getUserExpressList } from "@/apis/index";
// import cellInput from "@/components/cellInput";
import { mapState } from "vuex";
import { mobileReg } from "@/utils/validate";
import { playVoice } from "@/utils";
import { Toast } from 'vant';

export default {
  components: {
    // cellInput
  },
  data() {
    return {
      form: {
        secret: ""
      },
      showKeyboard: true,
      focusKey: "phone",
      time: 120 * 1000
    };
  },
  mounted() {
    // setTimeout(() => this.playTips(), 2000);
  },
  computed: {
    ...mapState(["stationInfo"])
  },
  methods: {
    focusKeyChange(key) {
      this.focusKey = key;
    },
    close() {
      const secret = this.form.secret;
      if (secret.length !== 6) {
        return this.$toast.fail("请输入正确的6位数取件码!");
      }
      this.getUserExpressList();
    },
    playTips() {
      playVoice("userPickerTips");
    },
    clickItem(e) {
      const arr = ["del", "confirm"];
      const val = this.form[this.focusKey];
      if (!arr.includes(e)) {
        this.form[this.focusKey] = val + e;
        // playVoice(e);
      } else if (e === "del") {
        this.form[this.focusKey] = val.slice(0, val.length - 1);
      } else if (e === "confirm") {
        const { phone, secret } = this.form;
        if (!phone) {
          this.$toast.fail("请输入手机号!");
          return;
        }
        if (!mobileReg.test(phone)) {
          this.$toast.fail("请输入正确手机号码!");
          // playVoice("wrangPhoneNo");
          return;
        }
        if (!secret) {
          this.$toast.fail("请输入取件码!");
          return;
        }
        this.getUserExpressList();
      }
    },
    async getUserExpressList() {
      const laoding = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "查询中..."
      });
      const [err, res] = await this.awaitTo(getUserExpressList(this.form));
      if (err) {
        this.$toast.fail(err.message);
        return;
      }
      if (res.length > 0) {
        this.$router.push({
          path: "/user/pick-list",
          query: this.form
        });
      } else {
        this.$toast.fail("您没有待取的包裹");
      }
      laoding.clear();
    },
    countdownfinish() {
      this.$router.push("/");
    },
    comfirmDialog() {
      this.resetCounter();
      this.form.phone = "";
      this.form.secret = "";
    },
    resetCounter() {
      this.$refs.countDown.reset();
    }
  }
};
</script>

<style lang="scss">
.user-pick {
  height: 100%;
  padding-top: rem(10);

  &-qrcode {
    background: #e4ecf2;
    padding: rem(24);
    width: rem(260);
    margin: rem(100) auto rem(40) auto;
    img {
      margin: 0 auto;
    }
  }
  .van-password-input {
    margin: 0 6px;
    margin-bottom: rem(30);
  }
  .van-number-keyboard {
    position: relative;
    padding-bottom: rem(20);
    .van-key {
      height: 64px;
    }
    .van-key--delete,
    .van-key--blue {
      height: 132px;
      font-size: rem(30);
    }
  }
  .van-password-input__security {
    height: 60px;
    li {
      font-size: rem(28);
    }
  }
  &-scantext {
    font-size: rem(28);

    .van-icon {
      vertical-align: middle;
      font-size: rem(32);
      color: #1db475;
      margin-right: rem(10);
    }
  }

  .van-row {
    height: 100%;
  }

  &-left {
    text-align: center;
    align-items: center;
    height: 100%;
    border-right: 1px solid #ddd;
  }

  &-right {
    height: 100%;

    .title {
      font-size: rem(28);
      text-align: center;
      margin-top: rem(20);
      margin-bottom: rem(20);
    }

    .right-content {
      width: 90%;
      padding: 0 5%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      background-color: #f2f3f5;
      .van-field,
      .van-cell {
        border: 1px solid #e1e3e6;
        margin-bottom: rem(12);
        font-size: rem(18);
        color: #333;

        &.focused {
          border-color: #1db475;

          .van-cell__value {
            &:after {
              content: "";
              border-right: 1px solid #999;
              margin-left: 2px;
              animation: flash 2.5s infinite;
            }
          }
        }
      }
    }

    .keybord {
      margin: -8px;

      &-row {
        display: flex;
      }

      &-item {
        height: rem(56);
        line-height: rem(56);
        margin: rem(8);
        font-size: rem(26);
        flex: 1;
        text-align: center;
        align-items: center;
        border-radius: 5px;
        background: #edf0f2;

        &:active {
          background: #6acaa2;
          color: #fff;
        }

        &.confirm {
          height: rem(132);
          line-height: rem(132);
        }
      }
    }
  }
}

@-webkit-keyframes flash {
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
}
</style>
